export default "__VITE_ASSET__Dd2vO1tV__"